import React from 'react';
import cx from 'classnames';

import { stepsConfig, stepsTitle } from '../../../../../components/steps/config/howToConfig';
import { StepsSection } from '../../../../../components/steps/StepsSection';
import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import { howItWorksSectionAnalyticsConfig, landingPageSectionLoadEvent, PAGE_SECTIONS } from '../../Pages/LandingPage.helpers';

import styles from './HowItWorks.scss';

type Props = {
  className?: string;
  stepsClassName?: string;
}

const HowItWorks = ({ className, stepsClassName }: Props) => {
  const onRefTrigger = () => landingPageSectionLoadEvent(PAGE_SECTIONS.HOW_IT_WORKS);

  const { setRef } = usePageRefEvents({ onRefTrigger });

  return (
    <section
      ref={(ref) => setRef(ref)}
      className={cx(styles.stepsSectionWrapper, className)}>
      <StepsSection
        analyticsConfig={howItWorksSectionAnalyticsConfig}
        config={stepsConfig()}
        stepsClassName={cx(styles.steps, stepsClassName)}
        title={stepsTitle as string}
      />
    </section>
  );
};

export default HowItWorks;
